import React from "react";
import ReactDOM from "react-dom";
import { Loader2 } from "lucide-react";
import logoSoftnik from "../image/Logo-softnik-positivo.png";
import "../css/LoadingOverlay.css";

const LoadingOverlay = ({
  // Por defecto `true`: varias pantallas lo montan condicionalmente
  // (`{loading && <LoadingOverlay />}`) sin pasar la prop, y así el overlay
  // nunca llegaba a dibujarse.
  isLoading = true,
  message = "Espere un momento, por favor\u2026",
  subMessage,
  showSpinner = false,
  onCancel,
}) => {
  if (!isLoading) return null;

  return ReactDOM.createPortal(
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <img className="loading-overlay__logo" src={logoSoftnik} alt={"Cargando\u2026"} />
      {showSpinner && (
        <Loader2
          size={56}
          style={{ color: "#005EAE", marginTop: "16px" }}
          aria-hidden="true"
          className="lucide-spin"
        />
      )}
      <div className="loading-overlay__text">{message}</div>
      {subMessage && <div className="loading-overlay__subtext">{subMessage}</div>}
      {onCancel && (
        <button
          type="button"
          className="loading-overlay__cancel"
          onClick={onCancel}
        >
          Cancelar
        </button>
      )}
    </div>,
    document.body
  );
};

export default React.memo(LoadingOverlay);
